/**
 * ## Seated Queue Controller
 *
 * @module src/controllers/seated
 */

"use strict";

const component = require("../../components/component");
const notification = require("../../components/notification");
const block = require("../../components/block");
const modal = require("../../components/modal");
const print = require("../../components/print");
const location = require("../../controllers/location");
const l = require("../../common").localization;

/** Init
 */
const init = (kd) => {
  const flyoutWaitlist = (target_id, activity_id) => {
    const options = {
      target_id,
      type: "accordion",
      mode: "context_seated",
      position: "left",
      adjust: {
        x: -5,
        y: 35,
      },
    };

    data.activity = kd.doc("activity", activity_id)[0];

    component.create(options, data, (err, data2) => {
      switch (data2.value) {
        case "backtoqueue": {
          let status = 1;
          if (
            data2.activity.hasOwnProperty("alerts") &&
            data2.activity.alerts > 0
          ) {
            status = 2;
          }
          const proposed = {
            domain: "activity",
            _id: data2.activity._id,
            status: 1,
          };
          kd.update(proposed)
            .then((result) => {
              const opt = {
                position: "top",
                width: "90%",
                seconds: 2,
                color: "#09e202",
                h1: l.translate("Party has been moved back to the queue"),
                body: "",
                buttons: [
                  {
                    description: l.translate("Close"),
                    value: "close",
                  },
                ],
              };
              notification.create(opt, {}, (err3, value) => {
                notification.destroy();
              });
            })
            .catch((err4) => {
              console.log("err4", err4);
            });
          break;
        }
        case "details": {
          opt = {
            width: "90%",
            type: "addparty",
            subtype: "waitlist",
            mode: "waitlist",
            h1: "Dialog Header",
            body: "This is the body text inside the dialog box",
            buttons: [
              {
                description: "cancel",
                value: "cancel...",
              },
              {
                description: "close",
                value: "close",
              },
              {
                description: "third",
                value: "close",
              },
            ],
          };

          const data = {
            kd,
            location: location.location,
            activity: data2.activity,
          };
          modal.create(opt, data, (err9, value) => {
            modal.destroy();
          });
          break;
        }
        case "printchit": {
          modal.destroy();
          setTimeout(() => {
            const opt = {
              type: "seated",
              location: location.location,
            };
            print.create(opt, data2.activity);
          }, 10);
          break;
        }
        default:
        // nothing
      }
    });
  };

  // longest

  let opt = {
    kd,
    targetDiv: "content_standard_seated",
    filter: {
      name: true,
      time: false,
      note: false,
      preference: false,
    },
  };

  const data = {
    type: "seated",
    domain: "activity",
    h1: l.translate("Seated Parties"),
    h2: "...",
    expand: true,
    single: false,
    group: "all",
    refresh: 30,
    height: {},
    status: {
      min: 3,
      max: 3,
    },
    size: {
      min: 1,
      max: 500,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(target_id, activity_id);
  });
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/seated/index.js
 **/